// extracted by mini-css-extract-plugin
export var clients_served = "index-module--clients_served--5806e";
export var stats_wrapper = "index-module--stats_wrapper--ff2d6";